var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex justify-content-center align-items-center",staticStyle:{"min-height":"100vh"}},[_c('b-spinner')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }